import { useState, useContext, useCallback, useMemo } from 'react';
import { DashboardContext, OrganisationContext } from '@database/contexts';
import { dashboardService, organisationService } from '@database/services';
import { ErrorType, Organisation } from '@utilities/types';

export const useOrganisation = () => {

    const { 
        organisation, setOrganisation,
        isUserAdmin, setIsUserAdmin,
    } = useContext(OrganisationContext);
    const { organisationMontlyRevenue, setOrganisationMontlyRevenue } = useContext(DashboardContext)

    const [isLoadingUpdatedOrganisation, setIsLoadingUpdatedOrganisation] = useState(false);
    const [updatedOrganisationError, setUpdatedOrganisationError] = useState<ErrorType | null>(null);
    const [getOrganisationMontlyRevenueError, setGetOrganisationMontlyRevenueError] = useState<ErrorType | null>(null);

    const isOrganisationInfosIsComplete = useMemo(() => !!(
        organisation && organisation.organisationName &&
        organisation.country && organisation.city
    ), [organisation]);

    const updateOrganisation = useCallback(async (updatedOrganisation: Partial<Organisation>) => {
        if(organisation){
            setIsLoadingUpdatedOrganisation(true);
            const req = await organisationService.update(organisation._id, updatedOrganisation);

            if(req.code === 200){
                setOrganisation(req.data);
                setUpdatedOrganisationError(null);
            } else {
                setUpdatedOrganisationError({
                    message: req.code === 404 ? "Entreprise non trouvée"
                             : "Erreur lors de la mise à jour de l'entreprise",
                });
            }
            setIsLoadingUpdatedOrganisation(false);
        }
    }, [organisation, setOrganisation]);

    const onGetOrganisationMontlyRevenue = useCallback(async () => {
        if(!organisation) return;

        const req = await dashboardService.getOrganisationMonthlyRevenueAndNextInvoiceDate(organisation._id);
        if(req.code === 200){
            setOrganisationMontlyRevenue(req.data);
            setGetOrganisationMontlyRevenueError(null);
        } else {
            setGetOrganisationMontlyRevenueError({
                message: req.code === 404 ? "Entreprise non trouvée"
                         : "Erreur lors de la récupération du chiffre d'affaire",
            });
        }
    }, [organisation, setOrganisationMontlyRevenue]);

    return {
        isLoadingUpdatedOrganisation,
        updatedOrganisationError,
        organisation,
        isOrganisationInfosIsComplete,
        organisationMontlyRevenue,
        getOrganisationMontlyRevenueError,
        isUserAdmin, setIsUserAdmin,
        setOrganisation,
        updateOrganisation,
        onGetOrganisationMontlyRevenue,
    };
};
